<template>
  <section>

    <h3 class="text-center">Add/Remove Users</h3>

    <div>
      <input type="text" class="form-control input-lg" @input="getAvailableUsers()" placeholder="Search for users to add" v-model="userSearchText">
    </div>

    <div v-if="loading" class="content content-centered">
      <pulse-loader></pulse-loader>
    </div>

    <div v-show="!loading">
      <div class="row content-centered" style="margin-top: 15px;">

        <div class="col-sm-5">

          <div class="box box-info box-solid">
            <div class="box-header">
              <h3 class="box-title" style="text-align: center;">Available Users</h3>
            </div>
            <div class="box-body">
              <select multiple ref="availablelist" size="10" style="width: 100%;"
                      v-model="selectedAvailableUsers" @change="selectedPermissionUsers = []">
                <option v-for="obj in availableUsers" v-bind:value="obj">
                  {{ (obj.user || {}).lastName }}, {{ (obj.user || {}).firstName }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-sm-2 content-centered">
          <div>
            <a @click="addUsers()">
              <i class="fa fa-arrow-circle-right fa-3x icon-btn icon-btn-primary"></i>
            </a>
            <br/>
            <br/>
            <a @click="removeUsers()">
              <i class="fa fa-arrow-circle-left fa-3x icon-btn icon-btn-info"></i>
            </a>
          </div>
        </div>

        <div class="col-sm-5">
          <div class="box box-primary box-solid">
            <div class="box-header">
              <h3 class="box-title">Current Users</h3>
            </div>
            <div class="box-body">
              <select multiple ref="permissionlist" size="10" style="width: 100%;"
                      v-model="selectedPermissionUsers" @change="selectedAvailableUsers = []">
                <option v-for="obj in newPermission.users" v-bind:value="obj">
                  {{ obj.user.lastName }}, {{ obj.user.firstName }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div>
        <input class="form-control" style="margin-top: 15px" :disabled="true" :placeholder="userDescription"/>
      </div>



      <div class="row content-centered">

       
       

      
      </div>

      <div v-show="newPermission._id" class="py-2 text-center row" style="margin-top: 10px">
        <button class="btn btn-primary" type="submit" @click="updatePermissionUsers" :disabled="!dirty">Update Permission Users</button>
      </div>
    </div>

  </section>
</template>

<script>
  import _ from 'lodash'
  import { eventBus, permissionService } from '../../../services'
  import { PERMISSION_STATES, EVENTS } from '../../../config'

  export default {
    name: 'PermissionUsers',
    props: ['permission'],
    data () {
      return {
        lodash: _,
        loading: null,
        dirty: false,
        newPermission: _.cloneDeep(this.permission),
        oldPermission: null,
        PERMISSION_STATES: PERMISSION_STATES,
        userSearchText: null,
        availableUsers: [],
        selectedAvailableUsers: [],
        selectedPermissionUsers: [],
      }
    },
    watch: {
      permission (val) {
        this.newPermission = _.cloneDeep(val)
        this.newPermission.users = this.newPermission.users || []
        this.getAvailableUsers()
        this.dirty = false
      }
    },
    computed: {
      userDescription () {
        const user = (this.selectedAvailableUsers[0] || {}).user || (this.selectedPermissionUsers[0] || {}).user
        if (user) {
          return user.email + ', ' + user.roleName
        }
        return 'Select a user to see their email and role.'
      },
    
    },
    methods: {
      getAvailableUsers () {
        this.loading = true
        const permissionUserIds = this.newPermission.users.map((object) => { return object.user._id })
        const params = {}
        if (this.userSearchText) {
          params.$term = this.userSearchText
          params.$searchFields = ['firstName', 'lastName', 'email']
        }
        if (!_.isEmpty(permissionUserIds)) {
          // Exclude the current permission users from the list of available users
          params.$exclude = permissionUserIds
        }
        return this.$userRepository.list(params)
          .then((response) => {
            this.loading = false
            this.availableUsers = response.data.docs.map((user) => {
              return { user }
            })
            this.sortLists()
          })
          .catch((error) => {
            this.loading = false
            console.error('PermissionUsers.getAvailableUsers-error:\n', error)
            this.$snotify.error('There was an error loading the users', 'Error!')
          })
      },
      addUsers () {
        this.dirty = true
        this.newPermission.users = this.newPermission.users.concat(this.selectedAvailableUsers)

        this.availableUsers = this.availableUsers.filter((object) => {
          return !this.selectedAvailableUsers.find((selectedObject) => {
            return selectedObject.user._id === object.user._id
          })
        })

        this.selectedAvailableUsers = []
        this.sortLists()
        eventBus.$emit(EVENTS.PERMISSION_USERS_UPDATED, this.newPermission.users)
      },
      removeUsers () {
        this.dirty = true
        this.availableUsers = this.availableUsers.concat(this.selectedPermissionUsers)

        this.newPermission.users = this.newPermission.users.filter((object) => {
          return !this.selectedPermissionUsers.find((selectedObject) => {
            return selectedObject.user._id === object.user._id
          })
        })

        this.selectedPermissionUsers = []
        this.sortLists()
        eventBus.$emit(EVENTS.PERMISSION_USERS_UPDATED, this.newPermission.users)
      },
      sortLists () {
        this.newPermission.users.sort((a, b) => { return a.user.lastName.localeCompare(b.user.lastName) })

        this.availableUsers.sort((a, b) => { return a.user.lastName.localeCompare(b.user.lastName) })
      },
      updatePermissionUsers () {
        permissionService.updatePermissionUsers(this.newPermission._id, this.newPermission.users, this.oldPermission.users)
          .then((response) => {
            this.loading = false
            this.dirty = false
            this.oldPermission = _.cloneDeep(this.newPermission)
            eventBus.$emit(EVENTS.PERMISSION_USERS_SAVED)
            this.$snotify.success('Permission users updated', 'Success!')
          })
          .catch((error) => {
            this.loading = false
            console.error('PermissionUsers.updatePermissionUsers-error:', error)
            this.$snotify.error('Update permission users failed', 'Error!')
          })
      }
    },
    created () {
      this.newPermission.users = this.newPermission.users || []
      this.oldPermission = _.cloneDeep(this.newPermission)
      this.getAvailableUsers()
    }
  }
</script>



// WEBPACK FOOTER //
// PermissionUsers.vue?4d3bac38